import styled from 'styled-components'

export const StyledMyPageQueriesSharedToYou = styled.div`
  padding: 0 15px;
`
